import { appKey } from './index'
import { DEPLOY_ENV } from '@/defines/env'
import Url from '@mc/mc-utils/js/url/url'

// 仅表示 URL 上的 mallType，不与后端业务字段混用
const url = new Url(window.location.href)
const urlQuery = url.parseQuerystring()
const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
export const mallType = urlQuery.mallType || hashQuery.mallType
const appKeyList = ['mall', 'small', 'tunxiaoba']
const currentAppKey = mallType === '4' ? 'tunxiaoba' : appKey
const _appKey = appKeyList.includes(currentAppKey) ? currentAppKey : 'mall'
// 豚小巴沿用美菜商城已有静态资源
const _assetAppKey = _appKey === 'tunxiaoba' ? 'mall' : _appKey

const APP_CONFIG_MAP = {
  // 美菜商城
  mall: {
    app_name: '美菜商城',
    app_short_name: '美菜',
    freight_name: '美菜运费',
    ossUrl: 'https://img-oss.yunshanmeicai.com/',
    domain: 'yunshanmeicai.com',
    themeColor: '#15BB5C',
    themeStartColor: '#37DF7E',
    themeEndColor: '#15BB5C',
    colorClass: 'mall-color',
    bgColorClass: 'mall-bg-color',
    lightBgColorClass: 'mall-light-bg-color',
    themeActiveColor: 'mall-color-active',
    borderColorClass: 'mall-color-border'
  },
  // 豚小巴
  tunxiaoba: {
    app_name: '豚小巴',
    app_short_name: '豚小巴',
    freight_name: '豚小巴运费',
    ossUrl: 'https://img-oss.yunshanmeicai.com/',
    domain: 'yunshanmeicai.com',
    themeColor: '#F03100',
    themeStartColor: '#F03100',
    themeEndColor: '#F03100',
    colorClass: 'tunxiaoba-color',
    bgColorClass: 'tunxiaoba-bg-color',
    lightBgColorClass: 'tunxiaoba-light-bg-color',
    themeActiveColor: 'tunxiaoba-color-active',
    borderColorClass: 'tunxiaoba-color-border'
  },
  // 小城市商城
  small: {
    app_name: '有鲜生活',
    app_short_name: '有鲜',
    freight_name: '运费',
    ossUrl: 'https://img-oss.linmontop.com.cn/',
    domain: 'linmontop.com.cn',
    themeColor: '#FF5019',
    themeStartColor: '#FF5E01',
    themeEndColor: '#FE2E31',
    colorClass: 'small-color',
    bgColorClass: 'small-bg-color',
    lightBgColorClass: 'small-light-bg-color',
    themeActiveColor: 'small-color-active',
    borderColorClass: 'small-color-border'
  }
}

export const PASSPORT_GATEWAY_ENV = {
  mall: {
    stage: 'stage',
    online: 'online'
  },
  small: {
    stage: 'smallDev',
    online: 'smallProd'
  },
  tunxiaoba: {
    stage: 'stage',
    online: 'online'
  }
}[_appKey][DEPLOY_ENV]

const MAIN_BG_MAP = {
  mall: 'https://img-oss.yunshanmeicai.com/spruce_material/45b2435abd4eb5deca1df9a6f43e1fbb',
  small:
    'https://img-oss.linmontop.com.cn/spruce_material/fd624b16e367c6e882894ca24795ecdb'
}

export const ossUrl = APP_CONFIG_MAP[_appKey].ossUrl
export const domain = APP_CONFIG_MAP[_appKey].domain

export const TRACER_FETCH_URL = {
  stage: `https://pre-logengine.${domain}/encryptLog`,
  online: `https://logengine.${domain}/encryptLog`
}[DEPLOY_ENV]

export const logoImg = require(`@/images/app/logo_${_assetAppKey}.png`)
export const goodDefaultImg = require(`@/images/empty/good_default_${_assetAppKey}.png`)
export const mainBgImg = MAIN_BG_MAP[_assetAppKey]

export const tree1Img = require(`@/images/money_tree/tree/tree1_2021_${_assetAppKey}.gif`)
export const thankTip1Img = require(`@/images/money_tree/tips/thank_2021_tip1_${_assetAppKey}.png`)
export const thankTip2Img = require(`@/images/money_tree/tips/thank_2021_tip2_${_assetAppKey}.png`)
export const thankTip3Img = require(`@/images/money_tree/tips/thank_2021_tip3_${_assetAppKey}.png`)
export const thankTip4Img = require(`@/images/money_tree/tips/thank_2021_tip4_${_assetAppKey}.png`)
export const thankTip5Img = require(`@/images/money_tree/tips/thank_2021_tip5_${_assetAppKey}.png`)

export const loseLottery0Img = require(`@/images/redPackageRain/loseLottery/lose_lottery0_${_assetAppKey}.png`)
export const loseLottery1Img = require(`@/images/redPackageRain/loseLottery/lose_lottery1_${_assetAppKey}.png`)
export const loseLottery2Img = require(`@/images/redPackageRain/loseLottery/lose_lottery2_${_assetAppKey}.png`)
export const loseLottery3Img = require(`@/images/redPackageRain/loseLottery/lose_lottery3_${_assetAppKey}.png`)
export const loseLottery4Img = require(`@/images/redPackageRain/loseLottery/lose_lottery4_${_assetAppKey}.png`)
export const mainTipsImg = require(`@/images/redPackageRain/main_tips_${_assetAppKey}.png`)
export const lotteryLuckBgImg = require(`@/images/redPackageRain/lotteryLuck/bg_lottery_luck_${_assetAppKey}.png`)
export const qrCodeImg = require(`@/images/new_good_req/qrcode_${_assetAppKey}.png`)
export const memberOpenBg = require(`@/images/member/open_bg_${_assetAppKey}.png`)

export const fileterAllDownImg = require(`@/images/activity_goods/all_down_active_${_assetAppKey}.png`)
export const fileterAllUpImg = require(`@/images/activity_goods/all_up_active_${_assetAppKey}.png`)
export const fileterDownImg = require(`@/images/activity_goods/d_${_assetAppKey}.png`)
export const fileterActiveImg = require(`@/images/activity_goods/filter_active_${_assetAppKey}.png`)
export const fileterUpImg = require(`@/images/activity_goods/up_${_assetAppKey}.png`)

export const APP_CONFIG = APP_CONFIG_MAP[_appKey]

const THEME_BG_CLASS_MAP = {
  mall: {
    // eslint-disable-next-line prettier/prettier
    'mall': true
  },
  // 小城市商城
  small: {
    // eslint-disable-next-line prettier/prettier
    'small': true
  },
  tunxiaoba: {
    // eslint-disable-next-line prettier/prettier
    'tunxiaoba': true
  }
}

export const COLOR_CLASS = APP_CONFIG_MAP[_appKey].colorClass
export const BG_COLOR_CLASS = APP_CONFIG_MAP[_appKey].bgColorClass
export const THEME_COLOR = APP_CONFIG_MAP[_appKey].themeColor
export const THEME_START_COLOR = APP_CONFIG_MAP[_appKey].themeStartColor
export const THEME_ENG_COLOR = APP_CONFIG_MAP[_appKey].themeEndColor
export const THEME_LIGHT_BG_COLOR = APP_CONFIG_MAP[_appKey].lightBgColorClass
export const THEME_BG_CLASS = THEME_BG_CLASS_MAP[_appKey]
export const BORDER_COLOR_CLASS = APP_CONFIG_MAP[_appKey].borderColorClass
